import { styled, GetProps, YStack, XStack } from 'tamagui'

// Vertical Stack (column direction)
export const VStack = styled(YStack, {
  name: 'VStack',
  
  variants: {
    gap: {
      xs: { gap: '$1' },
      sm: { gap: '$2' },
      md: { gap: '$4' },
      lg: { gap: '$6' },
      xl: { gap: '$8' },
    },
    align: {
      start: { alignItems: 'flex-start' },
      center: { alignItems: 'center' },
      end: { alignItems: 'flex-end' },
      stretch: { alignItems: 'stretch' },
    },
    justify: {
      start: { justifyContent: 'flex-start' },
      center: { justifyContent: 'center' },
      end: { justifyContent: 'flex-end' },
      between: { justifyContent: 'space-between' },
    },
  } as const,
  
  defaultVariants: {
    gap: 'md',
  },
})

// Horizontal Stack (row direction)
export const HStack = styled(XStack, {
  name: 'HStack',
  
  variants: {
    gap: {
      xs: { gap: '$1' },
      sm: { gap: '$2' },
      md: { gap: '$4' },
      lg: { gap: '$6' },
      xl: { gap: '$8' },
    },
    align: {
      start: { alignItems: 'flex-start' },
      center: { alignItems: 'center' },
      end: { alignItems: 'flex-end' },
      stretch: { alignItems: 'stretch' },
    },
    justify: {
      start: { justifyContent: 'flex-start' },
      center: { justifyContent: 'center' },
      end: { justifyContent: 'flex-end' },
      between: { justifyContent: 'space-between' },
    },
    wrap: {
      enabled: { flexWrap: 'wrap' },
      disabled: { flexWrap: 'nowrap' },
    },
  } as const,
  
  defaultVariants: {
    gap: 'md',
    align: 'center',
  },
})

// Generic Stack with direction prop
export const Stack = styled(YStack, {
  name: 'Stack',
  
  variants: {
    direction: {
      vertical: { flexDirection: 'column' },
      horizontal: { flexDirection: 'row' },
    },
    gap: {
      xs: { gap: '$1' },
      sm: { gap: '$2' },
      md: { gap: '$4' },
      lg: { gap: '$6' },
      xl: { gap: '$8' },
    },
    align: {
      start: { alignItems: 'flex-start' },
      center: { alignItems: 'center' },
      end: { alignItems: 'flex-end' },
      stretch: { alignItems: 'stretch' },
    },
    justify: {
      start: { justifyContent: 'flex-start' },
      center: { justifyContent: 'center' },
      end: { justifyContent: 'flex-end' },
      between: { justifyContent: 'space-between' },
    },
  } as const,
  
  defaultVariants: {
    direction: 'vertical',
    gap: 'md',
  },
})

export type VStackProps = GetProps<typeof VStack>
export type HStackProps = GetProps<typeof HStack>
export type StackProps = GetProps<typeof Stack>
